import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { useForceUpdate } from '../util';
import { contentIsEmpty } from './TaskMultiChoice';
import { FormValidityReporter } from '../FormValidity';
import { TabContextReporter } from '../TabContext';
import Dropdown from 'react-bootstrap/Dropdown';
import NumericInput from 'react-numeric-input';
import DestructiveButton from '../controls/DestructiveButton';
import { getRawText } from '../util';
export default function TaskFreeResponse(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const [validatorPrefix, setValidatorPrefix] = useState("At least");
  const [validatorType, setValidatorType] = useState("Words");
  const [validatorCount, setValidatorCount] = useState(3);
  const [validatorMessage, setValidatorMessage] = useState("A longer response is required");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "1. Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Prompt:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.label,
    onChange: v => {
      dataProps.label = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.label)
  }, "Label is empty")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Description:")), /*#__PURE__*/React.createElement(RichText, {
    value: dataProps.description,
    onChange: v => {
      dataProps.description = v;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: !contentIsEmpty(dataProps.description)
  }, "Description is empty")))), /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "1",
    title: "2. Validators"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Current Validators:")), dataProps.validators.map((v, k) => {
    return /*#__PURE__*/React.createElement(Row, {
      style: {
        marginLeft: "1rem"
      }
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, "Policy"), ":", /*#__PURE__*/React.createElement("br", null), v.validationType)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("b", null, "Message"), ":", /*#__PURE__*/React.createElement("br", null), getRawText(v.message))), /*#__PURE__*/React.createElement(Col, {
      xs: 2
    }, /*#__PURE__*/React.createElement(DestructiveButton, {
      size: "sm",
      variant: "danger",
      title: "Remove answer",
      text: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-trash"
      }),
      confirmation: /*#__PURE__*/React.createElement("i", {
        className: "bi bi-question-lg"
      }),
      className: "fs-sm",
      onClick: () => {
        dataProps.validators.splice(k, 1);
        forceUpdate();
        props.onChanged();
      }
    })));
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Validator Policy:")), /*#__PURE__*/React.createElement(Row, {
    style: {
      marginTop: ".5rem"
    }
  }, /*#__PURE__*/React.createElement(Col, {
    xs: 3
  }, /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2",
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, validatorPrefix), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      forceUpdate();
      props.onChanged();
      setValidatorPrefix("At least");
    }
  }, "At least"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      forceUpdate();
      props.onChanged();
      setValidatorPrefix("At most");
    }
  }, "At most")))), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(NumericInput, {
    style: {
      margin: 'auto'
    },
    size: "10",
    min: 0,
    value: validatorCount,
    onChange: e => {
      if (e) {
        setValidatorCount(e);
      } else {
        setValidatorCount(0);
      }
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 2
  }, /*#__PURE__*/React.createElement(Dropdown, {
    className: "mx-2",
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    id: "dropdown-basic"
  }, validatorType), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      forceUpdate();
      setValidatorType("Characters");
    }
  }, "Characters"), /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: e => {
      forceUpdate();
      setValidatorType("Words");
    }
  }, "Words"))))), /*#__PURE__*/React.createElement(Form.Label, {
    style: {
      marginTop: ".5rem"
    }
  }, /*#__PURE__*/React.createElement("b", null, "Validator Message:")), /*#__PURE__*/React.createElement(RichText, {
    value: validatorMessage,
    onChange: v => {
      setValidatorMessage(v);
      forceUpdate();
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Add a validator",
    variant: "success",
    style: {
      marginTop: '20px'
    },
    onClick: () => {
      let testFunction = undefined;
      switch (validatorType) {
        case "Words":
          if (validatorPrefix === "At least") testFunction = `return value.split(" ").length >= ${validatorCount}`;else if (validatorPrefix === "At most") testFunction = `return value.split(" ").length <= ${validatorCount}`;
          break;
        case "Characters":
          if (validatorPrefix === "At least") testFunction = `return value.length >= ${validatorCount}`;else if (validatorPrefix === "At most") testFunction = `return value.length <= ${validatorCount}`;
          break;
        default:
          break;
      }
      console.log("pushing, ", {
        strTest: testFunction,
        message: validatorMessage,
        validationType: `${validatorPrefix} ${validatorCount} ${validatorType}`
      });
      dataProps.validators.push({
        strTest: testFunction,
        message: validatorMessage,
        validationType: `${validatorPrefix} ${validatorCount} ${validatorType}`
      });
      forceUpdate();
      props.onChanged();
    }
  }, "Add Validator"))))));
}